import axios from 'axios'

export const getManagers = (params) => {
  return axios.get('manager/users', { params: params })
}

export const getManager = (params) => {
  return axios.get('manager/user/show', { params: params })
}

export const createManager = (data) => {
  return axios.post('manager/user/create', data)
}

export const editManager = (id, data) => {
  return axios.post('manager/user/edit/' + id, data)
}

export const resetPass = (data) => {
  return axios.post('manager/user/reset-password', data)
}

export const deleteManager = (data) => {
  return axios.post('manager/user/delete', data)
}



// WEBPACK FOOTER //
// ./src/api/managers.js